import { render, staticRenderFns } from "./StatusHeader.vue?vue&type=template&id=6a6713c2&scoped=true&"
import script from "./StatusHeader.vue?vue&type=script&lang=js&"
export * from "./StatusHeader.vue?vue&type=script&lang=js&"
import style0 from "./StatusHeader.vue?vue&type=style&index=0&id=6a6713c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6713c2",
  null
  
)

export default component.exports